module.exports = __webpack_public_path__ + "img/speaker-3.02f608db.png";